import { useEffect, useState } from "react";
import { useListenToProgress } from "../hooks/useListenToProgress";

type Args = {
  jobId: string | undefined;
  loading: boolean;
  refetching: boolean;
  autoResetAt100?: boolean;
};

export function useLoaderProgress({
  jobId,
  loading,
  refetching,
  autoResetAt100 = true,
}: Args) {
  const { data: progressData } = useListenToProgress(jobId ?? "");
  const percent = progressData?.listenToLoaderProgress?.percent;

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (typeof percent === "number" && !Number.isNaN(percent)) {
      const clamped = Math.max(0, Math.min(100, percent));

      setProgress(prev => Math.max(prev, clamped));
    }

    return () => {
      setProgress(0);
    };
  }, [percent]);

  useEffect(() => {
    if (loading || refetching) setProgress(0);
  }, [loading, refetching]);

  useEffect(() => {
    if (autoResetAt100 && !loading && !refetching && progress === 100) {
      setProgress(0);
    }
  }, [autoResetAt100, progress, loading, refetching]);

  const showLoader = loading || refetching || (progress > 0 && progress < 100);

  return { progress, showLoader };
}
